import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import TextareaAutosize from "react-autosize-textarea";
export const TextArea = React.forwardRef((props, forwardRef) => {
    const { onChange: propsOnChange, __fireOnChangeOnUnmount, onBlur: propsOnBlur, value: currentValue, onKeyDown, autoSize, ...rest } = props;
    const [value, setValue] = React.useState(currentValue);
    React.useEffect(() => {
        setValue(currentValue);
    }, [currentValue]);
    const onInput = (e) => {
        const targetValue = e.target.value;
        setValue(targetValue);
    };
    const onChange = (e) => {
        if (currentValue !== value) {
            propsOnChange?.(value);
        }
    };
    const onBlur = (e) => {
        onChange(e);
        propsOnBlur?.(e);
    };
    const onInputKeyDown = (e) => {
        onKeyDown?.(e);
        if (e.defaultPrevented) {
            onChange();
        }
    };
    if (autoSize)
        return _jsx(TextareaAutosize, { ...rest, 
            // maxRows={maxRows}
            ref: forwardRef, onChange: onInput, onKeyDown: __fireOnChangeOnUnmount ? onInputKeyDown : onKeyDown, onBlur: onBlur, value: value || "" });
    else
        return _jsx("textarea", { ...rest, ref: forwardRef, onChange: onInput, onKeyDown: __fireOnChangeOnUnmount ? onInputKeyDown : onKeyDown, onBlur: onBlur, value: value || "" });
});
